var constants = require('../constants');
var routeActions = require('react-router-redux').routerActions;

var SEEDS = {
    'promis': ["5506fb3a05bd0b61912acc5d"], // Symptom Tracker
    'myqol': ["54fccbed7f66556b2d000000"], // MyQ Quality of Life
    'gihistory': ["54ff7ac3dd1b51d714b608f3", "54fb8817b840e3039d000002"] // Doctor Visit Preparation
}

var Initialize = (function() {

    var _setSurveyList = function(surveyList, surveyType) {
        return {
            type: constants.SEED_SURVEY_LIST,
            surveyList: surveyList,
            surveyType: surveyType
        };
    }

    var _clearPreviousState = function() {
        return {
            type: constants.CLEAR_PREVIOUS_STATE
        };
    }

    var _seedSurveyList = function(surveyType, gender) {
        return function(dispatch, getState) {
            dispatch(_clearPreviousState());
            var surveyList = /^[a-f0-9]{24}$/.test(surveyType) ? [surveyType] : SEEDS[surveyType];

            if(surveyType === 'promis' && !getState().profile.data.contactForTrials && surveyList.indexOf('clinical_trials_opt_in_survey') === -1){
                surveyList.push('clinical_trials_opt_in_survey');
            }

            if(surveyList){
                dispatch(_setSurveyList(surveyList, surveyType));
            }else {
                dispatch(routeActions.replace('/not-found'));
            }
        };
    }

    var _shouldSeedSurveys = function(state, surveyType) {
        var surveys = state.surveys
        if (Object.keys(surveys.index).length === 0) {
            return true
        } else if (surveys.surveyType !== surveyType) {
            return true
        } else {
            return false
        }
    }

    var _seedSurveysIfNeeded = function(surveyType, gender) {
        surveyType = surveyType.toLowerCase();

        return function(dispatch, getState) {
            if (_shouldSeedSurveys(getState(), surveyType)) {
                return dispatch(_seedSurveyList(surveyType, gender))
            }
        }
    }

    return {
        clearPreviousState: _clearPreviousState,
        seedSurveysIfNeeded:_seedSurveysIfNeeded
    }
})();

module.exports = Initialize;



// WEBPACK FOOTER //
// ./src/common/modules/survey/actions/surveys-initialize.js